var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93477 7.80977L5.55977 12.1848C5.51913 12.2254 5.47087 12.2577 5.41776 12.2797C5.36465 12.3017 5.30773 12.313 5.25024 12.313C5.19276 12.313 5.13584 12.3017 5.08273 12.2797C5.02962 12.2577 4.98136 12.2254 4.94071 12.1848C4.90006 12.1441 4.86782 12.0959 4.84582 12.0428C4.82382 11.9897 4.8125 11.9327 4.8125 11.8752C4.8125 11.8178 4.82382 11.7608 4.84582 11.7077C4.86782 11.6546 4.90006 11.6064 4.94071 11.5657L9.00673 7.50024L4.94071 3.43477C4.85862 3.35268 4.8125 3.24134 4.8125 3.12524C4.8125 3.00915 4.85862 2.8978 4.94071 2.81571C5.0228 2.73362 5.13415 2.6875 5.25024 2.6875C5.36634 2.6875 5.47768 2.73362 5.55977 2.81571L9.93477 7.19071C9.97545 7.23134 10.0077 7.27959 10.0297 7.33271C10.0518 7.38582 10.0631 7.44275 10.0631 7.50024C10.0631 7.55774 10.0518 7.61467 10.0297 7.66778C10.0077 7.72089 9.97545 7.76914 9.93477 7.80977Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon_arrow_right.b86d814d2cec919fca425bca32638944.svg";
export { ForwardRef as ReactComponent };